export default __webpack_public_path__ + "static/media/bg-1of4.44ebda92.svg";